export { getWikisFromClient } from './getWikis.api';
export type { WikiPage } from './getWikis.api';
export { getWikiObjectByWikiid } from './getWikiByWikiid.api';
